import { useApiQuery } from '~/hooks';
import { getCryptoPricesApi } from '../repository';

export const CRYPTO_PRICE_QUERY_KEYS = {
  CRYPTO_PRICES: 'crypto-prices',
};

/**
 * Query hook to fetch cryptocurrency prices
 *
 * Prices are cached for 60 seconds to avoid excessive API calls
 *
 * @param symbols - Optional array of symbols to fetch (defaults to all)
 * @returns React Query result with prices
 *
 * @example
 * const { data: prices } = useGetCryptoPricesQuery(['BTC', 'ETH']);
 */
export const useGetCryptoPricesQuery = (symbols?: string[]) => {
  return useApiQuery({
    queryKey: symbols
      ? [CRYPTO_PRICE_QUERY_KEYS.CRYPTO_PRICES, ...symbols]
      : [CRYPTO_PRICE_QUERY_KEYS.CRYPTO_PRICES],
    queryFn: () => getCryptoPricesApi(symbols),
    staleTime: 60 * 1000, // Consider data fresh for 60 seconds
    gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
  });
};
